const PERMISSIONS_STORAGE_KEY = "permissions";

export function getStoredPermissions() {
  try {
    const value = JSON.parse(localStorage.getItem(PERMISSIONS_STORAGE_KEY));
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

export function hasPermission(code) {
  return getStoredPermissions().some((permission) => permission && permission.code === code);
}

export function canPublishBlog() {
  return hasPermission("PUBLICAR_BLOG");
}